


































































































import {Vue, Component} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import SearchProductForm from '@/views/statistic/sales/product/SearchProductForm.vue';
import ItemTable from '@/views/statistic/sales/product/ItemTable.vue';
import {i18nInObjectList} from '@/utils/i18n';
import {Mall, GetStatisticsSalesProduct, GetStatisticsSalesProductSummary, GetStatisticsSalesProductRequest} from 'supporter';
import TuiGrid from 'tui-grid';
import {changeDateFormat} from '@/utils/dateUtils';
import {createExcel} from '@/components/common/grid/ExcelCreateUtil';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';
@Component({
  components: {SearchProductForm, ItemTable, ExcelCreateButton}
})
export default class SalesStatisticProduct extends Vue {
  private partnerName: string = '';
  private brandName: string = '';
  private totalData: any[] = [];
  private totalData1: any[] = [];
  private detailData: any[] = [];
  private mallName: string = '';
  private startYMD: string = '';
  private endYMD: string = '';
  private totalCount: number = 0;
  private contentBottomOption = {
    havePageSizeBtn: false
  };

  /** 화폐단위 추가 */
  private addCurrencyCode({ value, currencyCode = 'KRW' }: { value: any, currencyCode?: string}) {
    if (value == null || isNaN(value) || Number(value) === 0) {
      return `0 ${currencyCode === 'KRW' ? '원' : currencyCode}`;
    }

    return `${value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} ${currencyCode === 'KRW' ? '원' : currencyCode}`;
  }

  private gridPropsDetail = {
    isShown: true,
    isShown1: false,
    columns: [
      {
        header: 'STATISTIC_SALES_MALLPRODUCTNO',
        name: 'mallProductNo',
        align: 'center',
        minWidth: 100,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_PRODUCTMANAGEMENTCD',
        name: 'productManagementCd',
        align: 'center',
        minWidth: 100,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_PRODUCTNAME',
        name: 'productName',
        align: 'left',
        minWidth: 180,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_MALLNAME',
        name: 'mallName',
        align: 'center',
        minWidth: 180,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_PARTNER',
        name: 'partnerName',
        align: 'center',
        minWidth: 180,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TARGET_TYPE_BRAND',
        name: 'brandName',
        align: 'center',
        minWidth: 180,
        formatter: function(cell: any) {
          if (cell.row.brandName == null || cell.row.brandName == '') {
            return '-';
          }
          return cell.row.brandName ;
        },
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_SALES_SALEMETHODTYPELABEL',
        name: 'saleMethodTypeLabel',
        align: 'center',
        minWidth: 80,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALORDERCNT',
        name: 'totalOrderCnt',
        align: 'center',
        minWidth: 80,
        formatter: function(cell: any) {
          if (cell.row.totalOrderCnt == null || isNaN(cell.row.totalOrderCnt)) {
            return 0;
          }
          return cell.row.totalOrderCnt.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALSALECNT',
        name: 'totalSaleCnt',
        align: 'center',
        minWidth: 80,
        formatter: function(cell: any) {
          if (cell.row.totalSaleCnt == null || isNaN(cell.row.totalSaleCnt)) {
            return 0;
          }
          return cell.row.totalSaleCnt.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALSALEAMT',
        name: 'totalSaleAmt',
        align: 'right',
        minWidth: 110,
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_PURCHASEYN',
        name: 'purchaseYn',
        align: 'center',
        minWidth: 80,
        formatter: function(cell: any) {
          if (cell.row.saleMethodType  == 'PURCHASE') {
            return '-';
          }
          if (cell.row.commissionRateType == 'PURCHASE_PRICE') {
            return 'Y';
          }
          return 'N';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALPURCHASEPRICE',
        name: 'totalPurchasePrice',
        align: 'right',
        minWidth: 80,
        formatter: (data: any) => {
          if (data.row.commissionRateType === 'PURCHASE_PRICE') {
            if (data.row.totalPurchaseAmt == null || isNaN(data.row.totalPurchaseAmt)) {
              return '-';
            }
            return this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode });
          } else {
            return '-';
          }
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALSUPPLYPRICE',
        name: 'totalSupplyPrice',
        align: 'right',
        minWidth: 80,
        formatter: (data: any) => {
          if (data.row.saleMethodType === 'PURCHASE') {
            if (data.row.totalSupplyAmt == null || isNaN(data.row.totalSupplyAmt)) {
              return '-';
            }
            return this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode });
          } else {
            return '-';
          }
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_COMMISSIONRATE',
        name: 'commissionRate',
        align: 'center',
        minWidth: 80,
        formatter: function(cell: any) {
          if (cell.row.commissionRateType === 'PURCHASE_PRICE' || cell.row.saleMethodType === 'PURCHASE') {
            return '-';
          }
          return cell.row.commissionRate.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + '%';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALCOMMISSIONAMT',
        name: 'totalCommissionAmt',
        align: 'right',
        minWidth: 120,
        formatter: (data: any) => {
          if (data.row.totalCommissionAmt == null || isNaN(data.row.totalCommissionAmt)) {
            return '-';
          }
          return this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode });
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALMALLPROMOTIONAMT',
        name: 'totalMallPromotionAmt',
        align: 'right',
        minWidth: 200,
        formatter: (data: any) => {
          if (data.row.totalMallPromotionAmt == null || isNaN(data.row.totalMallPromotionAmt)) {
            return '-';
          }
          return this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode });
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALPARTNERPROMOTIONAMT',
        name: 'totalPartnerPromotionAmt',
        align: 'right',
        minWidth: 200,
        formatter: (data: any) => {
          if (data.row.totalPartnerPromotionAmt == null || isNaN(data.row.totalPartnerPromotionAmt)) {
            return '-';
          }
          return this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode });
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALMALLPROFITAMT',
        name: 'totalMallProfitAmt',
        align: 'right',
        minWidth: 180,
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_CATEGORYNAME',
        name: 'fullCategoryName',
        align: 'center',
        minWidth: 180,
        formatter: function(cell: any) {
          return cell.row.fullCategoryName
        },
        copyOptions: {
          useFormattedValue: true,
          // customValue: (data: any): any => {
          //   return data.toString().split('>').join('＞')
          // }
        }
      },
      {
        header: 'STATISTIC_SALES_EXCELBTN',
        name: 'excelBtn',
        align: 'center',
        minWidth: 100,
        formatter: function(cell: any) {
          return `<button type="button" class="excelBtn excelDetail" data-start-ymd="${cell.row.startYMD}" data-end-ymd="${cell.row.endYMD}" data-product-no="${cell.row.mallProductNo}" data-product-no="${cell.row.mallOptionNo}" data-download-type="UNIT" data-date-type="PERIOD">${window.$t('COMMON_DOWNLOAD')}</button>`;
        }
      }
    ],
    header: {
      height: 35,
      columns: [
        {
          name: 'purchaseYn',
          renderer: ({columnInfo}: any): any => {
            const div = document.createElement('div');
            div.innerHTML = columnInfo.header.split('@').join('<br>');
            return {
              getElement(): any {
                return div;
              },
              render(): void {}
            };
          }
        }
      ]
    },
    columns1: [
      {
        header: 'STATISTIC_SALES_MALLPRODUCTNO',
        name: 'mallProductNo',
        align: 'center',
        minWidth: 80,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_PRODUCTMANAGEMENTCD',
        name: 'productManagementCd',
        align: 'center',
        minWidth: 80,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_PRODUCTNAME',
        name: 'productName',
        align: 'left',
        minWidth: 180,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_MALLOPTIONNO',
        name: 'mallOptionNo',
        align: 'center',
        minWidth: 80,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_DISPLAYOPTIONNAME',
        name: 'displayOptionName',
        align: 'left',
        minWidth: 150,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_MALLNAME',
        name: 'mallName',
        align: 'center',
        minWidth: 180,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_PARTNER',
        name: 'partnerName',
        align: 'center',
        minWidth: 180,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TARGET_TYPE_BRAND',
        name: 'brandName',
        align: 'center',
        minWidth: 180,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_SALEMETHODTYPELABEL',
        name: 'saleMethodTypeLabel',
        align: 'center',
        minWidth: 80,
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALORDERCNT',
        name: 'totalOrderCnt',
        align: 'center',
        minWidth: 80,
        formatter: function(cell: any) {
          if (cell.row.totalOrderCnt == null || isNaN(cell.row.totalOrderCnt)) {
            return '-';
          }
          return cell.row.totalOrderCnt.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALSALECNT',
        name: 'totalSaleCnt',
        align: 'center',
        minWidth: 80,
        formatter: function(cell: any) {
          if (cell.row.totalSaleCnt == null || isNaN(cell.row.totalSaleCnt)) {
            return '-';
          }
          return cell.row.totalSaleCnt.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALSALEAMT',
        name: 'totalSaleAmt',
        align: 'right',
        minWidth: 110,
        formatter: (data: any) => {
          if (data.row.totalSaleAmt == null || isNaN(data.row.totalSaleAmt)) {
            return '-';
          }
          return this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode });
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_PURCHASEYN',
        name: 'purchaseYn',
        align: 'center',
        minWidth: 80,
        formatter: function(cell: any) {
          if (cell.row.saleMethodType  == 'PURCHASE') {
            return '-';
          }
          if (cell.row.commissionRateType == 'PURCHASE_PRICE') {
            return 'Y';
          }
          return 'N';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALPURCHASEPRICE',
        name: 'totalPurchasePrice',
        align: 'right',
        minWidth: 80,
        formatter: (data: any) =>  {
          if (data.row.commissionRateType === 'PURCHASE_PRICE') {
            if (data.row.totalPurchaseAmt == null || isNaN(data.row.totalPurchaseAmt)) {
              return '-';
            }
            return this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode });
          } else {
            return '-';
          }
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALSUPPLYPRICE',
        name: 'totalSupplyPrice',
        align: 'right',
        minWidth: 80,
        formatter: (data: any) => {
          if (data.row.saleMethodType === 'PURCHASE') {
            if (data.row.totalSupplyAmt == null || isNaN(data.row.totalSupplyAmt)) {
              return '-';
            }
            return this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode });
          } else {
            return '-';
          }
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_COMMISSIONRATE',
        name: 'commissionRate',
        align: 'center',
        minWidth: 80,
        formatter: function(cell: any) {
          if (cell.row.commissionRate == null || isNaN(cell.row.commissionRate)) {
            return '-';
          }
          return cell.row.commissionRate.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + '%';
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALCOMMISSIONAMT',
        name: 'totalCommissionAmt',
        align: 'right',
        minWidth: 120,
        formatter: (data: any) => {
          if (data.row.totalCommissionAmt == null || isNaN(data.row.totalCommissionAmt)) {
            return '-';
          }
          return this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode });
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALMALLPROMOTIONAMT',
        name: 'totalMallPromotionAmt',
        align: 'right',
        minWidth: 180,
        formatter: (data: any) => {
          if (data.row.totalMallPromotionAmt == null || isNaN(data.row.totalMallPromotionAmt)) {
            return '-';
          }
          return this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode });
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALPARTNERPROMOTIONAMT',
        name: 'totalPartnerPromotionAmt',
        align: 'right',
        minWidth: 180,
        formatter: (data: any) => {
          if (data.row.totalPartnerPromotionAmt == null || isNaN(data.row.totalPartnerPromotionAmt)) {
            return '-';
          }
          return this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode });
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALPAYAMT',
        name: 'totalPayAmt',
        align: 'right',
        minWidth: 180,
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALMALLPROFITAMT',
        name: 'totalMallProfitAmt',
        align: 'right',
        minWidth: 180,
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_CATEGORYNAME',
        name: 'fullCategoryName',
        align: 'center',
        minWidth: 180,
        formatter: function(cell: any) {
          return cell.row.fullCategoryName
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: 'STATISTIC_SALES_EXCELBTN',
        name: 'excelBtn',
        align: 'center',
        minWidth: 100,
        formatter: function(cell: any) {
          return `<button type="button" class="excelBtn excelDetail" data-start-ymd="${cell.row.startYMD}" data-end-ymd="${cell.row.endYMD}" data-product-no="${cell.row.mallProductNo}" data-product-no="${cell.row.mallOptionNo}" data-download-type="UNIT" data-date-type="PERIOD">${window.$t('COMMON_DOWNLOAD')}</button>`;
        }
      }
    ],
    options: {
      columnOptions: {
        resizable: true
      },
      pageOptions: {
        perPage: 100,
        page: 1,
        totalCount: 0
      }
    },
    options1: {
      columnOptions: {
        resizable: true
      },
      pageOptions: {
        perPage: 100,
        page: 1,
        totalCount: 0
      }
    }
  };
  private gridProps = {
    isShown: true,
    isShown1: true,
    columns: [
      {
        header: 'STATISTIC_SALES_TOTALORDERCNT',
        name: 'totalOrderCnt',
        align: 'center',
        formatter: function(cell: any) {
          if (cell.row.totalOrderCnt == null || isNaN(cell.row.totalOrderCnt)) {
            return 0;
          }
          return cell.row.totalOrderCnt.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALPRODUCTCNT',
        name: 'totalProductCnt',
        align: 'center',
        formatter: function(cell: any) {
          if (cell.row.totalProductCnt == null || isNaN(cell.row.totalProductCnt)) {
            return 0;
          }
          return cell.row.totalProductCnt.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALSALECNT',
        name: 'totalSaleCnt',
        align: 'center',
        formatter: function(cell: any) {
          if (cell.row.totalSaleCnt == null || isNaN(cell.row.totalSaleCnt)) {
            return 0;
          }
          return cell.row.totalSaleCnt.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALSALEAMT',
        name: 'totalSaleAmt',
        align: 'right',
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
      },
      {
        header: 'STATISTIC_SALES_TOTALPRODUCTPROMOTIONDISCOUNTAMT',
        name: 'totalProductPromotionDiscountAmt',
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
      },
      {
        header: 'STATISTIC_SALES_TOTALPRODUCTSALEAMT',
        name: 'totalProductSaleAmt',
        align: 'center',
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
      },
      {
        header: 'STATISTIC_SALES_EXCELBTN',
        name: 'excelBtn',
        align: 'center',
        formatter: function(cell: any) {
          return `<button type="button" class="excelBtn excelAll" data-start-ymd="${cell.row.startYMD}" data-end-ymd="${cell.row.endYMD}" data-download-type="ALL">${window.$t('COMMON_DOWNLOAD')}</button>`;
        }
      }
    ],
    columns1: [
      {
        header: 'STATISTIC_SALES_PROMOTIONTYPE',
        name: 'promotionType',
        align: 'center'
      },
      {
        header: 'STATISTIC_SALES_TOTALPROMOTIONAMT',
        name: 'totalPromotionAmt',
        align: 'right',
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
      },

      {
        header: 'STATISTIC_SALES_TOTALMALLDISCOUNTAMT',
        name: 'totalMallDiscountAmt',
        align: 'right',
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
      },
      {
        header: 'STATISTIC_SALES_MALLDISCOUNTRATE',
        name: 'mallDiscountRate',
        align: 'right',
        formatter: function(cell: any) {
          if (cell.row.mallDiscountRate == null || isNaN(cell.row.mallDiscountRate)) {
            return 0;
          }
          return cell.row.mallDiscountRate.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALPARTNERDISCOUNTAMT',
        name: 'totalPartnerDiscountAmt',
        align: 'right',
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
      },
      {
        header: 'STATISTIC_SALES_PARTNERDISCOUNTRATE',
        name: 'partnerDiscountRate',
        align: 'right',
        formatter: function(cell: any) {
          if (cell.row.partnerDiscountRate == null || isNaN(cell.row.partnerDiscountRate)) {
            return 0;
          }
          return cell.row.partnerDiscountRate.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
      }
    ],
    options1: {
      scrollX: false,
      scrollY: false,
      columnOptions: {
        minWidth: 10,
        resizable: true
      },
      header: {
        height: 65,
        complexColumns: [
          {
            header: 'STATISTIC_SALES_MERGEMALL',
            name: 'mergeMall',
            childNames: ['totalMallDiscountAmt', 'mallDiscountRate']
          },
          {
            header: 'STATISTIC_SALES_MERGEPARTNER',
            name: 'mergePartner',
            childNames: ['totalPartnerDiscountAmt', 'partnerDiscountRate']
          }
        ]
      }
    },
    options: {
      scrollX: false,
      scrollY: false,
      minBodyHeight: 33,
      columnOptions: {
        resizable: true
      }
    }
  };
  private searchRequest: GetStatisticsSalesProductRequest = null;
  private setSearchRequest(request:GetStatisticsSalesProductRequest){
    this.searchRequest = request
  }

  private get searchRequestParams() {
    const params = this.searchRequest ? {...this.searchRequest.params} : {}
    for (const key in params) {
      if (!params[key] && params[key] !== false) delete params[key];
    }
    return params;
  }

  private created() {
    const noData = this.$t('STATISTIC_SALES_PERIOD_INIT_NODATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    this.isNaberPayMall();
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns1', 'header');
    this.gridProps.options1.header = i18nInObjectList(this, this.gridProps.options1.header, 'complexColumns', 'header');
    this.gridPropsDetail = i18nInObjectList(this, this.gridPropsDetail, 'columns', 'header');
    this.gridPropsDetail = i18nInObjectList(this, this.gridPropsDetail, 'columns1', 'header');
  }
  private search(page: number = 1, size: number) {
    const noData = this.$t('STATISTIC_SALES_PERIOD_SEARCH_NODATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    const searchForm: any = this.$refs.searchProductForm;
    searchForm.searchBtnClick(page, size);
  }

  private get statisticsProductMenuKey() {
    return this.searchRequest?.params?.productType === 'PRODUCT' ? 'PREMIUM_STATISTICS_PRODUCT' : 'PREMIUM_STATISTICS_OPTION'
  }

  private get statisticsProductExtraInfo() {
    const startYmd = this.searchRequest?.params?.startYmd ?? '';
    const endYmd = this.searchRequest?.params?.endYmd ?? '';

    return `${changeDateFormat(startYmd, 'YYYYMMDD')}_${changeDateFormat(endYmd, 'YYYYMMDD')}`
  }

  private setData(salesProductcontents: GetStatisticsSalesProduct, salesProductSummarycontents: GetStatisticsSalesProductSummary, page: number, size: number, mallName: string, productType: string) {
    const noData = this.$t('STATISTIC_SALES_PERIOD_SEARCH_NODATA') as string;
    const currencyCode = salesProductSummarycontents.currencyCode;

    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    this.startYMD = salesProductSummarycontents.startYmd;
    this.endYMD = salesProductSummarycontents.endYmd;
    // if (new Date(this.endYMD.replace(/-/g, '/')).getMonth() == new Date().getMonth()){
    //   this.endYMD = changeDateFormat(new Date(), 'YYYY-MM-DD')
    // }
    this.mallName = mallName;
    this.partnerName = (this.$refs.searchProductForm as any).partnerName;
    this.brandName = (this.$refs.searchProductForm as any).brandName;
    const arry: any[] = [];
    const val = {
      totalOrderCnt: salesProductSummarycontents.summary.totalOrderCnt,
      totalProductCnt: salesProductSummarycontents.summary.totalProductCnt,
      totalSaleCnt: salesProductSummarycontents.summary.totalSaleCnt,
      totalSaleAmt: salesProductSummarycontents.summary.totalSaleAmt,
      totalProductPromotionDiscountAmt: salesProductSummarycontents.summary.totalProductPromotionDiscountAmt,
      totalProductSaleAmt: salesProductSummarycontents.summary.totalProductSaleAmt,
      startYMD: this.startYMD,
      endYMD: this.endYMD,
      currencyCode,
    };
    arry.push(val);
    this.totalData = arry;

    const totalCount = salesProductSummarycontents.promotionSummary.totalAdditionalDiscountAmt + salesProductSummarycontents.promotionSummary.totalProductCouponAmt;
    this.totalData1 = [
      {
        promotionType: '소계',
        totalPromotionAmt: totalCount,
        totalMallDiscountAmt: salesProductSummarycontents.promotionSummary.totalMallAdditionalDiscountAmt + salesProductSummarycontents.promotionSummary.totalProductCouponAmt,
        mallDiscountRate:
          totalCount === 0
            ? 0
            : Math.round(((salesProductSummarycontents.promotionSummary.totalMallAdditionalDiscountAmt + salesProductSummarycontents.promotionSummary.totalProductCouponAmt) / totalCount) * 100 * Math.pow(10, 1)) / Math.pow(10, 1),
            //((salesProductSummarycontents.promotionSummary.totalMallAdditionalDiscountAmt + salesProductSummarycontents.promotionSummary.totalProductCouponAmt) / totalCount* 100).toFixed(1),
        totalPartnerDiscountAmt: salesProductSummarycontents.promotionSummary.totalPartnerAdditionalDiscountAmt,
        partnerDiscountRate:
          totalCount === 0
            ? 0
            : Math.round(((salesProductSummarycontents.promotionSummary.totalPartnerAdditionalDiscountAmt + salesProductSummarycontents.promotionSummary.totalPartnerProductCouponAmt) / totalCount) * 100 * Math.pow(10, 1)) / Math.pow(10, 1),
        currencyCode
      },
      {
        promotionType: '추가할인',
        totalPromotionAmt: salesProductSummarycontents.promotionSummary.totalAdditionalDiscountAmt,
        totalMallDiscountAmt: salesProductSummarycontents.promotionSummary.totalMallAdditionalDiscountAmt,
        mallDiscountRate:
          salesProductSummarycontents.promotionSummary.totalAdditionalDiscountAmt === 0
            ? 0
            : Math.round((salesProductSummarycontents.promotionSummary.totalMallAdditionalDiscountAmt / salesProductSummarycontents.promotionSummary.totalAdditionalDiscountAmt) * 100 * Math.pow(10, 1)) / Math.pow(10, 1),
        totalPartnerDiscountAmt: salesProductSummarycontents.promotionSummary.totalPartnerAdditionalDiscountAmt,
        partnerDiscountRate:
          salesProductSummarycontents.promotionSummary.totalAdditionalDiscountAmt === 0
            ? 0
            : Math.round((salesProductSummarycontents.promotionSummary.totalPartnerAdditionalDiscountAmt / salesProductSummarycontents.promotionSummary.totalAdditionalDiscountAmt) * 100 * Math.pow(10, 1)) / Math.pow(10, 1),
        currencyCode
      },
      {
        promotionType: '상품금액할인',
        totalPromotionAmt: salesProductSummarycontents.promotionSummary.totalProductCouponAmt,
        totalMallDiscountAmt: salesProductSummarycontents.promotionSummary.totalMallProductCouponAmt,
        mallDiscountRate:
          salesProductSummarycontents.promotionSummary.totalProductCouponAmt === 0
            ? 0
            : Math.round((salesProductSummarycontents.promotionSummary.totalMallProductCouponAmt / salesProductSummarycontents.promotionSummary.totalProductCouponAmt) * 100 * Math.pow(10, 1)) / Math.pow(10, 1),
        totalPartnerDiscountAmt: salesProductSummarycontents.promotionSummary.totalPartnerProductCouponAmt,
        partnerDiscountRate:
          salesProductSummarycontents.promotionSummary.totalProductCouponAmt === 0
            ? 0
            : Math.round((salesProductSummarycontents.promotionSummary.totalPartnerProductCouponAmt / salesProductSummarycontents.promotionSummary.totalProductCouponAmt) * 100 * Math.pow(10, 1)) / Math.pow(10, 1),
        currencyCode
      },
      {
        promotionType: '사은품할인',
        totalPromotionAmt: salesProductSummarycontents.promotionSummary.totalFreeGiftAmt,
        totalMallDiscountAmt: salesProductSummarycontents.promotionSummary.totalMallFreeGiftAmt,
        mallDiscountRate: this.calculateDiscountRate(salesProductSummarycontents.promotionSummary.totalFreeGiftAmt, salesProductSummarycontents.promotionSummary.totalMallFreeGiftAmt),
        totalPartnerDiscountAmt: salesProductSummarycontents.promotionSummary.totalPartnerFreeGiftAmt,
        partnerDiscountRate: this.calculateDiscountRate(salesProductSummarycontents.promotionSummary.totalFreeGiftAmt, salesProductSummarycontents.promotionSummary.totalPartnerFreeGiftAmt),
        currencyCode
      }
    ];

    this.detailData = salesProductcontents.contents.map(contentitem => {
      return {...contentitem, startYMD: this.startYMD, endYMD: this.endYMD, mallName: mallName};
    });
    this.gridPropsDetail.options.pageOptions.page = page;
    this.gridPropsDetail.options.pageOptions.perPage = size;
    this.gridPropsDetail.options.pageOptions.totalCount = salesProductcontents.totalCount;
    this.totalCount = salesProductcontents.totalCount;
    if (productType == 'PRODUCT') {
      this.gridPropsDetail.isShown = true;
      this.gridPropsDetail.isShown1 = false;
    } else {
      this.gridPropsDetail.isShown1 = true;
      this.gridPropsDetail.isShown = false;
    }

    if (this.detailData.length == 0){
      this.totalData1 = []
    }
  }
  
  private calculateDiscountRate(totalAmt: number, totalPartialAmt: number): number {
    return totalAmt === 0
      ? 0
      : Math.round((totalPartialAmt / totalAmt) * 100 * Math.pow(10, 1)) / Math.pow(10, 1)
  }

  private useNaverPay: boolean = false;
  @Getter('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private async isNaberPayMall() {
    this.malls.forEach((item: any) => {
      this.setIsNaverPayMall(item.mallNo);
    });
  }
  private setIsNaverPayMall(mallNo: number) {
    const orderConfigRequest = {
      pathParams: {
        mallNo: String(mallNo)
      },
      params: {
        key: 'ORDER_CONFIG' // 결제수단 조회
      }
    };
    this.$api.getMallsConfigurations(orderConfigRequest).then(ret => {
      if (ret && ret.data) {
        this.useNaverPay = this.useNaverPay || ret.data.useNaverPay;
      }
    });
  }

  private async mounted() {
    $('body').on('click', '.excelAll', $.proxy(this.excelAll, this));
    $('body').on('click', '.excelDetail', $.proxy(this.excelDetail, this));
    // $('body').on('click', '.excelAll', () => {});
    // $('body').on('click', '.excelDetail', (e) => {});
  }
  private genderTypeValidate(): boolean {
    if (this.searchRequest.params.genderTypes === '') {
      alert(this.$t('VERIFY_MESSAGE_GENDER'));
      return false;
    }
    return true;
  }
  private excelDetail(e: any){
    if (!this.genderTypeValidate()) return;
    const dateNow = new Date().getTime();
    const excelDownRequest: any = {
      params: {
        categoryDepth: '', //  要搜索的类别深度
        categoryNo: '', //  类别号
        couponType: '', //  优惠券类型
        displayBrandNo: '', //  展览品牌号
        displayCategoryNo: '', //  展览分类号
        endYmd: '', // *  结束日期
        genderTypes: '', // *  会员性别
        includesClaim: '', //  클레임구분
        keyword: '', //  검색어 입력
        mallNo: '', // * mall
        memberGradeNo: '', //  会员等级
        memberGroupNo: '', //  会员组
        memberType: '', // * 会员类型
        page: '', // * page
        partnerNo: '', //  파트너번호
        payType: '', //  支付手段
        platformTypes: '', // * 平台类型（pc web app）
        productNos: '', // 商品编号列表
        productType: '', //  商品查询标准
        promotionKeywordType: '', //  促销搜索关键字类型
        promotionType: '', //  宣传搜索类型
        saleMethodType: '', //  销售方式区分
        size: '', // * size
        startYmd: '', // *  开始日期
        discountNo: null
      }
    };
      excelDownRequest.params.categoryDepth = this.searchRequest.params.categoryDepth
      excelDownRequest.params.categoryNo = this.searchRequest.params.categoryNo
      excelDownRequest.params.displayBrandNo = this.searchRequest.params.displayBrandNo
      excelDownRequest.params.displayCategoryNo = this.searchRequest.params.displayCategoryNo
      excelDownRequest.params.endYmd = this.searchRequest.params.endYmd
      excelDownRequest.params.genderTypes = this.searchRequest.params.genderTypes
      excelDownRequest.params.includesClaim = this.searchRequest.params.includesClaim
      excelDownRequest.params.mallNo = this.searchRequest.params.mallNo
      excelDownRequest.params.memberGradeNo = this.searchRequest.params.memberGradeNo
      excelDownRequest.params.memberGroupNo = this.searchRequest.params.memberGroupNo
      excelDownRequest.params.memberType = this.searchRequest.params.memberType
      excelDownRequest.params.page = '1';
      excelDownRequest.params.size = '30';
      excelDownRequest.params.partnerNo = this.searchRequest.params.partnerNo
      excelDownRequest.params.payType = this.searchRequest.params.payType
      excelDownRequest.params.platformTypes = this.searchRequest.params.platformTypes
      excelDownRequest.params.productNos = $(e.target).data('productNo')
      excelDownRequest.params.productType = this.searchRequest.params.productType
      excelDownRequest.params.saleMethodType = this.searchRequest.params.saleMethodType
      excelDownRequest.params.startYmd = this.searchRequest.params.startYmd

      const endYmd = new Date(this.searchRequest.params.endYmd.replace(/-/g, '/')).getMonth() == new Date().getMonth()?changeDateFormat(new Date(), 'YYYY-MM-DD'):this.searchRequest.params.endYmd
      createExcel(this, this.detailData.length > 0, excelDownRequest.params, 'PREMIUM_STATISTICS_SALE_PRODUCT_DETAIL', $(e.target).data('productNo')+'_'+changeDateFormat(excelDownRequest.params.startYmd, 'YYYYMMDD') + '_' + changeDateFormat(endYmd, 'YYYYMMDD'));
  }
  private excelAll(){
    if (!this.genderTypeValidate()) return;
    const dateNow = new Date().getTime();
    const excelDownRequest: any = {
      params: {
        categoryDepth: '', //  要搜索的类别深度
        categoryNo: '', //  类别号
        couponType: '', //  优惠券类型
        displayBrandNo: '', //  展览品牌号
        displayCategoryNo: '', //  展览分类号
        endYmd: '', // *  结束日期
        genderTypes: '', // *  会员性别
        includesClaim: '', //  클레임구분
        keyword: '', //  검색어 입력
        mallNo: '', // * mall
        memberGradeNo: '', //  会员等级
        memberGroupNo: '', //  会员组
        memberType: '', // * 会员类型
        page: '', // * page
        partnerNo: '', //  파트너번호
        payType: '', //  支付手段
        platformTypes: '', // * 平台类型（pc web app）
        productNos: '', // 商品编号列表
        productType: '', //  商品查询标准
        promotionKeywordType: '', //  促销搜索关键字类型
        promotionType: '', //  宣传搜索类型
        saleMethodType: '', //  销售方式区分
        size: '', // * size
        startYmd: '', // *  开始日期
        discountNo: null
      }
    };
      excelDownRequest.params.categoryDepth = this.searchRequest.params.categoryDepth
      excelDownRequest.params.categoryNo = this.searchRequest.params.categoryNo
      excelDownRequest.params.displayBrandNo = this.searchRequest.params.displayBrandNo
      excelDownRequest.params.displayCategoryNo = this.searchRequest.params.displayCategoryNo
      excelDownRequest.params.endYmd = this.searchRequest.params.endYmd
      excelDownRequest.params.genderTypes = this.searchRequest.params.genderTypes
      excelDownRequest.params.includesClaim = this.searchRequest.params.includesClaim
      excelDownRequest.params.mallNo = this.searchRequest.params.mallNo
      excelDownRequest.params.memberGradeNo = this.searchRequest.params.memberGradeNo
      excelDownRequest.params.memberGroupNo = this.searchRequest.params.memberGroupNo
      excelDownRequest.params.memberType = this.searchRequest.params.memberType
      excelDownRequest.params.page = '1';
      excelDownRequest.params.size = '30';
      excelDownRequest.params.partnerNo = this.searchRequest.params.partnerNo
      excelDownRequest.params.payType = this.searchRequest.params.payType
      excelDownRequest.params.platformTypes = this.searchRequest.params.platformTypes
      excelDownRequest.params.productNos = this.searchRequest.params.productNos
      excelDownRequest.params.productType = this.searchRequest.params.productType
      excelDownRequest.params.saleMethodType = this.searchRequest.params.saleMethodType
      excelDownRequest.params.startYmd = this.searchRequest.params.startYmd

      const endYmd = new Date(this.searchRequest.params.endYmd.replace(/-/g, '/')).getMonth() == new Date().getMonth()?changeDateFormat(new Date(), 'YYYY-MM-DD'):this.searchRequest.params.endYmd
      createExcel(this, this.detailData.length > 0, excelDownRequest.params, 'PREMIUM_STATISTICS_SALE_PRODUCT_PERIOD', changeDateFormat(excelDownRequest.params.startYmd, 'YYYYMMDD') + '_' + changeDateFormat(endYmd, 'YYYYMMDD'));
  }
  private beforeDestroy(){
    $('body').off('click', '.excelAll', $.proxy(this.excelAll, this));
    $('body').off('click', '.excelDetail', $.proxy(this.excelDetail, this));
  }

  private onTabClick(urlPath:string){
    if (this.$route.path === urlPath) {
        this.$router.go(0);
        return;
    }

    this.$router.push({
        path: urlPath,
      });
  }
}
